import type {
    DiscountType,
    Invoice,
    InvoiceLine,
    Payment
} from '@/types'

import { roundMoney } from '@/lib/carwash/format'

export const calculateDiscount = (subtotal: number, type: DiscountType, value: number): number => {
    const safeValue = Math.max(0, Number.isFinite(value) ? value : 0)
    const raw = type === 'percent'
        ? (subtotal * Math.min(safeValue, 100)) / 100
        : Math.min(safeValue, subtotal)

    return roundMoney(raw)
}

export const calculateTotals = (lines: InvoiceLine[], discountType: DiscountType, discountValue: number) => {
    const subtotal = roundMoney(lines.reduce((sum, line) => sum + line.amount, 0))
    const discountAmount = calculateDiscount(subtotal, discountType, discountValue)

    return {
        subtotal,
        discountAmount,
        total: roundMoney(subtotal - discountAmount)
    }
}

export const getActivePayment = (payments: Payment[], invoiceId: string): Payment | null => {
    const matches = payments.filter(payment => payment.invoiceId === invoiceId && !payment.voidedAt)
    return matches.length ? matches[matches.length - 1] : null
}

export const describeDiscount = (invoice: Pick<Invoice, 'discountType' | 'discountValue'>): string => {
    if (!invoice.discountValue) return 'No discount'
    return invoice.discountType === 'percent' ? `${invoice.discountValue}% off` : 'Flat discount'
}
